import Axios from "axios";
import type { AxiosError } from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";
import type { FleetConfig, LEZ, APIError, ResidentialEmissionMap, ResidentialTotalEmissionMap } from "src/types";

export type LEZMutationData = Omit<LEZ, "id">;
export type FleetConfigMutationData = FleetConfig;

export async function queryFn(runYear: number) {
  const url = `/planning-api/residentialmaps/${runYear}`;
  try {
    const response = await Axios.get<ResidentialMapsResponse>(url);

    return response.data;
  } catch (error) {
    console.error(error);
    return {
      mapList: [],
      totalMapList: [],
    };
  }
}

interface ResidentialMapsResponse {
  mapList: ResidentialEmissionMap[];
  totalMapList: ResidentialTotalEmissionMap[];
}

export function useResidentialMaps(runYear: number) {
  return useQuery<ResidentialMapsResponse, AxiosError<APIError[]>>(baseDataKeys.residentialMaps(runYear), () =>
    queryFn(runYear)
  );
}
